import * as THREE from 'three';

export default function getProjectionMatrix(cameraData) {
  const projectionMatrix = new THREE.Matrix4();
  if (cameraData.projection === 'Orthographic') {
    const size =  computeCameraSize(true, cameraData) || { width: 1, height: 1 };
    projectionMatrix.makeOrthographic(-size.width, size.width, size.height, -size.height, cameraData.nearClip, cameraData.farClip);
  } else {
    // const filmSizeVec = new THREE.Vector2(cameraData.get('filmSize'),
    //     cameraData.get('filmSize') * cameraData.get('aspectRatio'));
    //  console.log(navigator.getProjectionMatrix:, data.fieldOfView, data.aspectRatio);

    const ymax = cameraData.nearClip * Math.tan( THREE.Math.DEG2RAD * cameraData.fieldOfView * 0.5 );
    const ymin = - ymax;
    const xmin = ymin * cameraData.aspectRatio;
    const xmax = ymax * cameraData.aspectRatio;

    return projectionMatrix.makePerspective( xmin, xmax, ymax, ymin, cameraData.nearClip, cameraData.farClip );

  }

  return projectionMatrix;
}

function computeCameraSize( halfSize, cameraData ) {

  if( !(cameraData && cameraData.fieldOfView && cameraData.orthoZoom && cameraData.aspectRatio) ) return false

  const tangent = Math.tan( THREE.Math.degToRad( cameraData.fieldOfView / 2 ) )
  const camHeight_half = tangent * cameraData.orthoZoom;
  const camWidth_half = camHeight_half * cameraData.aspectRatio;

  //  Horizontal fov ?
  // var hFOV_Half = Math.atan( Math.tan( this.fieldOfView / 2 ) * this.aspectRatio );
  // var camWidth = Math.tan( hFOV_Half ) * dist * 2;

  if ( halfSize === true ) {
    return {width: camWidth_half, height: camHeight_half};

  } else {
    return {width: camWidth_half * 2, height: camHeight_half * 2};
  }
}




// WEBPACK FOOTER //
// ./src/translators/utils/getProjectionMatrix.js